import React from 'react';
import { createRoot } from 'react-dom/client'; // New React 18 API
import App from './App'; // Import your App component with routing and auth
import './index.css';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);